import React, { Suspense, useEffect, useState } from 'react';
import { Route } from 'react-router';
import { setLocale } from 'yup';
import { ScrollContextProvider } from './components/GridComponents/ScrollContextProvider';
import { Layout } from './components/Layout';
import { Loading } from './components/Loading';
import MenuTablet from './components/MenuTablet';
import i18n from './i18n';
import { LoginPage } from './components/Login/LoginPage';
import AppCustom from './AppCustom';


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('value');

const Home = React.lazy(() => import('./components/Home'));

const REG101 = React.lazy(() => import('./pages/_custom/registro/REG101'));
const REG705 = React.lazy(() => import('./pages/registro/REG705'));
const REG080 = React.lazy(() => import('./pages/registro/REG080'));
const REG855 = React.lazy(() => import('./pages/_custom/registro/REG855'));

const PRE640 = React.lazy(() => import('./pages/preparacion/PRE640'));
const PRE660 = React.lazy(() => import('./pages/preparacion/PRE660'));
const PRE450 = React.lazy(() => import('./pages/preparacion/PRE450'));
const PRE460 = React.lazy(() => import('./pages/preparacion/PRE460'));
const PRE670 = React.lazy(() => import('./pages/preparacion/PRE670'));
const PRE680 = React.lazy(() => import('./pages/preparacion/PRE680'));
const PRE220 = React.lazy(() => import('./pages/_custom/preparacion/PRE220'));
const PRE221 = React.lazy(() => import('./pages/_custom/preparacion/PRE221'));
const PRE130 = React.lazy(() => import('./pages/_custom/preparacion/PRE130'));
const COF070 = React.lazy(() => import('./pages/_custom/preparacion/COF070'));

const INT100 = React.lazy(() => import('./pages/_custom/interfaz/INT100'));

const INV010 = React.lazy(() => import('./pages/inventario/INV010'));
const INV030 = React.lazy(() => import('./pages/inventario/INV030'));
const INV040 = React.lazy(() => import('./pages/inventario/INV040'));
const INV060 = React.lazy(() => import('./pages/inventario/INV060'));
const INV050 = React.lazy(() => import('./pages/inventario/INV050'));
const INV100 = React.lazy(() => import('./pages/inventario/INV100'));
const INV410 = React.lazy(() => import('./pages/inventario/INV410'));
const INV411 = React.lazy(() => import('./pages/inventario/INV411'));
const INV412 = React.lazy(() => import('./pages/inventario/INV412'));
const INV413 = React.lazy(() => import('./pages/inventario/INV413'));
const INV414 = React.lazy(() => import('./pages/inventario/INV414'));

const REC010 = React.lazy(() => import('./pages/_custom/recepcion/REC010'));
const REC020 = React.lazy(() => import('./pages/_custom/recepcion/REC020'));
const REC023 = React.lazy(() => import('./pages/_custom/recepcion/REC023'));
const REC011 = React.lazy(() => import('./pages/_custom/recepcion/REC011'));
const REC200 = React.lazy(() => import('./pages/recepcion/REC200'));
const REC210 = React.lazy(() => import('./pages/recepcion/REC210'));
const REC710 = React.lazy(() => import('./pages/recepcion/REC710'));
const REC250 = React.lazy(() => import('./pages/recepcion/REC250'));
const REC260 = React.lazy(() => import('./pages/_custom/recepcion/REC260'));
const REC220 = React.lazy(() => import('./pages/_custom/recepcion/REC220'));
const REC270 = React.lazy(() => import('./pages/_custom/recepcion/REC270'));
const REC280 = React.lazy(() => import('./pages/_custom/recepcion/REC280'));
const REC380 = React.lazy(() => import('./pages/_custom/recepcion/REC380'));
const REC380Detalle = React.lazy(() => import('./pages/_custom/recepcion/REC380Detalle'));
const REC400 = React.lazy(() => import('./pages/_custom/recepcion/REC400'));
const REC170ImpresionEtiq = React.lazy(() => import('./pages/_custom/recepcion/REC170ImpresionEtiq'));

const SEG210 = React.lazy(() => import('./pages/seguridad/SEG210'));
const SEG070 = React.lazy(() => import('./pages/_custom/seguridad/SEG070'));
const SEG750 = React.lazy(() => import('./pages/_custom/seguridad/SEG750'));
const SEG100 = React.lazy(() => import('./pages/_custom/seguridad/SEG100'));

const STO060 = React.lazy(() => import('./pages/_custom/stock/STO060'));
//const STO395 = React.lazy(() => import('./pages/stock/STO395'));
const STO150 = React.lazy(() => import('./pages/_custom/stock/STO150'));
const STO151 = React.lazy(() => import('./pages/stock/STO151'));
const STO210 = React.lazy(() => import('./pages/stock/STO210'));
const STO211 = React.lazy(() => import('./pages/stock/STO211'));
const STO640 = React.lazy(() => import('./pages/stock/STO640'));
const STO500 = React.lazy(() => import('./pages/_custom/stock/STO500'));
const STO666 = React.lazy(() => import('./pages/_custom/stock/STO666'));
const STO667 = React.lazy(() => import('./pages/_custom/stock/STO667'));
const STO498 = React.lazy(() => import('./pages/_custom/stock/STO498'));

const STO800 = React.lazy(() => import('./pages/_custom/stock/STO800'));
const STO152 = React.lazy(() => import('./pages/_custom/stock/STO152'));


const EXP320 = React.lazy(() => import('./pages/expedicion/EXP320'));
const EXP050 = React.lazy(() => import('./pages/expedicion/EXP050'));
const EXP330 = React.lazy(() => import('./pages/_custom/expedicion/EXP330'));
const EXP400 = React.lazy(() => import('./pages/expedicion/EXP400'));
const EXP041 = React.lazy(() => import('./pages/_custom/expedicion/EXP041'));
const EXP321 = React.lazy(() => import('./pages/_custom/expedicion/EXP321'));
const EXP560 = React.lazy(() => import('./pages/_custom/expedicion/EXP560'));
const EXP600 = React.lazy(() => import('./pages/_custom/expedicion/EXP600'));

const AUT010 = React.lazy(() => import('./pages/automatizacion/AUT010'));

const EVT000 = React.lazy(() => import('./pages/evento/EVT000'));
const EVT001 = React.lazy(() => import('./pages/evento/EVT001'));
const EVT002 = React.lazy(() => import('./pages/evento/EVT002'));
const EVT010 = React.lazy(() => import('./pages/evento/EVT010'));
const EVT020 = React.lazy(() => import('./pages/evento/EVT020'));
const EVT030 = React.lazy(() => import('./pages/evento/EVT030'));
const EVT040 = React.lazy(() => import('./pages/evento/EVT040'));
const EVT050 = React.lazy(() => import('./pages/evento/EVT050'));

const POR010 = React.lazy(() => import('./pages/porteria/POR010'));
const POR020 = React.lazy(() => import('./pages/porteria/POR020'));
const POR030 = React.lazy(() => import('./pages/porteria/POR030'));
const POR060 = React.lazy(() => import('./pages/porteria/POR060'));
const POR070 = React.lazy(() => import('./pages/porteria/POR070'));
const POR040 = React.lazy(() => import('./pages/porteria/POR040'));
const POR050 = React.lazy(() => import('./pages/porteria/POR050'));
const POR080 = React.lazy(() => import('./pages/porteria/POR080'));

const PRD100 = React.lazy(() => import('./pages/_custom/produccion/PRD100'));
const PRD110 = React.lazy(() => import('./pages/produccion/PRD110'));
const PRD120 = React.lazy(() => import('./pages/produccion/PRD120'));
const PRD150 = React.lazy(() => import('./pages/produccion/PRD150'));
const PRD151 = React.lazy(() => import('./pages/produccion/PRD151'));
const PRD170 = React.lazy(() => import('./pages/produccion/PRD170'));
const PRD171 = React.lazy(() => import('./pages/produccion/PRD171'));
const PRD175 = React.lazy(() => import('./pages/produccion/PRD175'));
const PRD180 = React.lazy(() => import('./pages/produccion/PRD180'));
const PRD190 = React.lazy(() => import('./pages/produccion/PRD190'));

const STO750 = React.lazy(() => import('./pages/_custom/stock/STO750'));
const STO510 = React.lazy(() => import('./pages/_custom/stock/STO510'));
const STO330 = React.lazy(() => import('./pages/_custom/stock/STO330'));
const PRE760Custom = React.lazy(() => import('./pages/_custom/preparacion/PRE760Custom'));



const PRE109 = React.lazy(() => import('./pages/_custom/preparacion/PRE109'));
const PRE100 = React.lazy(() => import('./pages/_custom/preparacion/PRE100'));
const PRE150 = React.lazy(() => import('./pages/_custom/preparacion/PRE150'));

const FAC006 = React.lazy(() => import('./pages/_custom/facturacion/FAC006'));
const FAC003 = React.lazy(() => import('./pages/_custom/facturacion/FAC003'));
const FAC010 = React.lazy(() => import('./pages/_custom/facturacion/FAC010'));

const FAC412 = React.lazy(() => import('./pages/_custom/facturacion/FAC412'));
const FAC413 = React.lazy(() => import('./pages/_custom/facturacion/FAC413'));
const FAC414 = React.lazy(() => import('./pages/_custom/facturacion/FAC414'));
const FAC009 = React.lazy(() => import('./pages/_custom/facturacion/FAC009'));
const FAC450 = React.lazy(() => import('./pages/_custom/facturacion/FAC450'));
const FAC008 = React.lazy(() => import('./pages/_custom/facturacion/FAC008'));
const FAC400 = React.lazy(() => import('./pages/_custom/facturacion/FAC400'));
const FAC401 = React.lazy(() => import('./pages/_custom/facturacion/FAC401'));
const FAC402 = React.lazy(() => import('./pages/_custom/facturacion/FAC402'));
const FAC404 = React.lazy(() => import('./pages/_custom/facturacion/FAC404'));
const FAC411 = React.lazy(() => import('./pages/_custom/facturacion/FAC411'));
const FAC415 = React.lazy(() => import('./pages/_custom/facturacion/FAC415'));

const CTL010 = React.lazy(() => import('./pages/control/CTL010'));
const CTL020 = React.lazy(() => import('./pages/control/CTL020'));
const CTL030 = React.lazy(() => import('./pages/control/CTL030'));
const CTL040 = React.lazy(() => import('./pages/control/CTL040'));

setLocale({
    mixed: {
        required: i18n.t("General_Sec0_Error_Error25")
    },
    string: {
        required: i18n.t("General_Sec0_Error_Error25"),
        max: i18n.t("General_Sec0_Error_LargoMaxExcedido")
    },
    number: {
        required: i18n.t("General_Sec0_Error_Error25")
    },
    date: {
        required: i18n.t("General_Sec0_Error_Error25")
    }
});


export default function App(props) {

    const [doneLoading, setDoneLoading] = useState(false);
    const [userName, setUserName] = useState("");
    const [userLanguage, setUserLanguage] = useState("");
    const [versionSistema, setversionSistema] = useState("");
    const [isModeTablet, setIsModeTablet] = useState(false);
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        const request = {
            method: "POST",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            }
        };

        fetch("/Security/GetUserData", request)
            .then(d => {
                if (d.status === 401)
                    throw "Authorization Error";

                return d.json();
            })
            .then(d => {
                setUserName(d.UserName);
                setUserLanguage(d.Language);
                setIsModeTablet(d.IsModeTablet);
                setversionSistema(d.VersionSistema);
                setDoneLoading(true);
            })
            .catch(d => {
                if (window.location.pathname !== "/Login" && window.location.pathname !== "/Security/Logout" && window.location.pathname !== "/Redirect/RedirectToApp")
                    window.location = "/Security/Logout";

                if (window.location.pathname === "/Login") {
                    setIsLogin(true);
                }
            });
    }, []);

    const changeLanguage = (language) => {
        setUserLanguage(language);

        const request = {
            method: "POST",
            cache: "no-cache",
            body: JSON.stringify({
                Language: language
            }),
            headers: {
                "Content-Type": "application/json"
            }
        };

        fetch("/Security/UpdateUserLanguage", request).then(d => d);
    };

    i18n.changeLanguage(userLanguage);

    if (doneLoading) {
        return (
            <Layout
                userName={userName}
                userLanguage={userLanguage}
                VersionSistema={versionSistema}
                changeLanguage={changeLanguage}
                isModeTablet={isModeTablet}
            >

                <AppCustom />

                <ScrollContextProvider>
                    <Suspense fallback={<Loading />}>
                        <Route exact path={baseUrl + '/'} render={() => <Home />} />

                        <Route path={baseUrl + '/Menu'} render={() => <MenuTablet />} />

                        <Route path='/control/CTL010' render={(props) => <CTL010 {...props} />} />
                        <Route path='/control/CTL020' render={(props) => <CTL020 {...props} />} />
                        <Route path='/control/CTL030' render={(props) => <CTL030 {...props} />} />
                        <Route path='/control/CTL040' render={(props) => <CTL040 {...props} />} />

                        <Route path={baseUrl + '/registro/REG101'} render={(props) => <REG101 {...props} />} />
                        <Route path={baseUrl + '/registro/REG705'} render={(props) => <REG705 {...props} />} />
                        <Route path={baseUrl + '/registro/REG080'} render={(props) => <REG080 {...props} />} />
                        <Route path={baseUrl + '/registro/REG855'} render={(props) => <REG855 {...props} />} />

                        <Route path={baseUrl + '/seguridad/SEG750'} render={(props) => <SEG750 {...props} />} />

                        <Route path={baseUrl + '/preparacion/PRE640'} render={(props) => <PRE640 {...props} />} />
                        <Route path={baseUrl + '/preparacion/PRE460'} render={(props) => <PRE460 {...props} />} />
                        <Route path={baseUrl + '/preparacion/PRE660'} render={(props) => <PRE660 {...props} />} />
                        <Route path={baseUrl + '/preparacion/PRE670'} render={(props) => <PRE670 {...props} />} />
                        <Route path={baseUrl + '/preparacion/PRE450'} render={(props) => <PRE450 {...props} />} />
                        <Route path={baseUrl + '/preparacion/PRE680'} render={(props) => <PRE680 {...props} />} />
                        <Route path={baseUrl + '/preparacion/PRE130'} render={(props) => <PRE130 {...props} />} />
                        <Route path={baseUrl + '/preparacion/PRE220'} render={(props) => <PRE220 {...props} />} />
                        <Route path={baseUrl + '/preparacion/PRE221'} render={(props) => <PRE221 {...props} />} />

                        <Route path={baseUrl + '/interfaz/INT100'} render={(props) => <INT100 {...props} />} />


                        <Route path={baseUrl + '/inventario/INV010'} render={(props) => <INV010 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV030'} render={(props) => <INV030 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV040'} render={(props) => <INV040 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV050'} render={(props) => <INV050 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV060'} render={(props) => <INV060 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV100'} render={(props) => <INV100 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV410'} render={(props) => <INV410 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV411'} render={(props) => <INV411 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV412'} render={(props) => <INV412 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV413'} render={(props) => <INV413 {...props} />} />
                        <Route path={baseUrl + '/inventario/INV414'} render={(props) => <INV414 {...props} />} />

                        <Route path={baseUrl + '/recepcion/REC010'} render={(props) => <REC010 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC020'} render={(props) => <REC020 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC023'} render={(props) => <REC023 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC011'} render={(props) => <REC011 {...props} />} />

                        <Route path={baseUrl + '/recepcion/REC200'} render={(props) => <REC200 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC210'} render={(props) => <REC210 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC710'} render={(props) => <REC710 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC250'} render={(props) => <REC250 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC260'} render={(props) => <REC260 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC220'} render={(props) => <REC220 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC270'} render={(props) => <REC270 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC280'} render={(props) => <REC280 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC400'} render={(props) => <REC400 {...props} />} />
                        <Route path={baseUrl + '/recepcion/REC170ImpresionEtiq'} render={(props) => <REC170ImpresionEtiq {...props} />} />

                        <Route path={baseUrl + '/seguridad/SEG210'} render={(props) => <SEG210 {...props} />} />
                        <Route path={baseUrl + '/seguridad/SEG070'} render={(props) => <SEG070 {...props} />} />
                        <Route path={baseUrl + '/seguridad/SEG100'} render={(props) => <SEG100 {...props} />} />

                        <Route path={baseUrl + '/expedicion/EXP320'} render={(props) => <EXP320 {...props} />} />
                        <Route path={baseUrl + '/expedicion/EXP050'} render={(props) => <EXP050 {...props} />} />
                        <Route path={baseUrl + '/expedicion/EXP330'} render={(props) => <EXP330 {...props} />} />
                        <Route path={baseUrl + '/expedicion/EXP400'} render={(props) => <EXP400 {...props} />} />
                        <Route path={baseUrl + '/expedicion/EXP041'} render={(props) => <EXP041 {...props} />} />
                        <Route path={baseUrl + '/expedicion/EXP321'} render={(props) => <EXP321 {...props} />} />
                        <Route path={baseUrl + '/expedicion/EXP560'} render={(props) => <EXP560 {...props} />} />
                        <Route path={baseUrl + '/expedicion/EXP600'} render={(props) => <EXP600 {...props} />} />

                        
                        <Route path={baseUrl + '/stock/STO150'} render={(props) => <STO150 {...props} />} />
                        <Route path={baseUrl + '/stock/STO151'} render={(props) => <STO151 {...props} />} />
                        <Route path={baseUrl + '/stock/STO210'} render={(props) => <STO210 {...props} />} />
                        <Route path={baseUrl + '/stock/STO211'} render={(props) => <STO211 {...props} />} />
                        <Route path={baseUrl + '/stock/STO640'} render={(props) => <STO640 {...props} />} />
                        <Route path={baseUrl + '/stock/STO500'} render={(props) => <STO500 {...props} />} />
                        <Route path={baseUrl + '/stock/STO750'} render={(props) => <STO750 {...props} />} />
                        <Route path={baseUrl + '/stock/STO510'} render={(props) => <STO510 {...props} />} />
                        <Route path={baseUrl + '/stock/STO330'} render={(props) => <STO330 {...props} />} />
                        <Route path={baseUrl + '/stock/STO060'} render={(props) => <STO060 {...props} />} />
                        <Route path={baseUrl + '/stock/STO152'} render={(props) => <STO152 {...props} />} />
                        <Route path={baseUrl + '/stock/STO666'} render={(props) => <STO666 {...props} />} />
                        <Route path={baseUrl + '/stock/STO667'} render={(props) => <STO667 {...props} />} />
                        <Route path={baseUrl + '/stock/STO498'} render={(props) => <STO498 {...props} />} />
                        <Route path={baseUrl + '/stock/STO800'} render={(props) => <STO800 {...props} />} />

                        <Route path={baseUrl + '/automatizacion/AUT010'} render={(props) => <AUT010 {...props} />} />

                        <Route path={baseUrl + '/evento/EVT000'} render={(props) => <EVT000 {...props} />} />
                        <Route path={baseUrl + '/evento/EVT001'} render={(props) => <EVT001 {...props} />} />
                        <Route path={baseUrl + '/evento/EVT002'} render={(props) => <EVT002 {...props} />} />
                        <Route path={baseUrl + '/evento/EVT010'} render={(props) => <EVT010 {...props} />} />
                        <Route path={baseUrl + '/evento/EVT020'} render={(props) => <EVT020 {...props} />} />
                        <Route path={baseUrl + '/evento/EVT030'} render={(props) => <EVT030 {...props} />} />
                        <Route path={baseUrl + '/evento/EVT040'} render={(props) => <EVT040 {...props} />} />
                        <Route path={baseUrl + '/evento/EVT050'} render={(props) => <EVT050 {...props} />} />

                        <Route path={baseUrl + '/porteria/POR010'} render={(props) => <POR010 {...props} />} />
                        <Route path={baseUrl + '/porteria/POR020'} render={(props) => <POR020 {...props} />} />
                        <Route path={baseUrl + '/porteria/POR030'} render={(props) => <POR030 {...props} />} />
                        <Route path={baseUrl + '/porteria/POR060'} render={(props) => <POR060 {...props} />} />
                        <Route path={baseUrl + '/porteria/POR070'} render={(props) => <POR070 {...props} />} />
                        <Route path={baseUrl + '/porteria/POR040'} render={(props) => <POR040 {...props} />} />
                        <Route path={baseUrl + '/porteria/POR050'} render={(props) => <POR050 {...props} />} />
                        <Route path={baseUrl + '/porteria/POR080'} render={(props) => <POR080 {...props} />} />

                        <Route path={baseUrl + '/produccion/PRD100'} render={(props) => <PRD100 {...props} />} />
                        <Route path={baseUrl + '/produccion/PRD110'} render={(props) => <PRD110 {...props} />} />
                        <Route path={baseUrl + '/produccion/PRD120'} render={(props) => <PRD120 {...props} />} />
                        <Route path={baseUrl + '/produccion/PRD150'} render={(props) => <PRD150 {...props} />} />
                        <Route path={baseUrl + '/produccion/PRD151'} render={(props) => <PRD151 {...props} />} />
                        <Route path={baseUrl + '/produccion/PRD170'} render={(props) => <PRD170 {...props} />} />
                        <Route path={baseUrl + '/produccion/PRD171'} render={(props) => <PRD171 {...props} />} />
                        <Route path={baseUrl + '/produccion/PRD175'} render={(props) => <PRD175 {...props} />} />
                        <Route path={baseUrl + '/produccion/PRD180'} render={(props) => <PRD180 {...props} />} />
                        <Route path={baseUrl + '/produccion/PRD190'} render={(props) => <PRD190 {...props} />} />

                        <Route path='/facturacion/FAC006' render={(props) => <FAC006 {...props} />} />     
                        <Route path='/facturacion/FAC003' render={(props) => <FAC003 {...props} />} />
                        <Route path='/facturacion/FAC010' render={(props) => <FAC010 {...props} />} />

                        <Route path='/facturacion/FAC412' render={(props) => <FAC412 {...props} />} />     
                        <Route path='/facturacion/FAC413' render={(props) => <FAC413 {...props} />} />     
                        <Route path='/facturacion/FAC414' render={(props) => <FAC414 {...props} />} />     
                        <Route path='/facturacion/FAC009' render={(props) => <FAC009 {...props} />} />     
                        <Route path='/facturacion/FAC450' render={(props) => <FAC450 {...props} />} />     
                        <Route path='/facturacion/FAC008' render={(props) => <FAC008 {...props} />} />     
                        <Route path='/facturacion/FAC400' render={(props) => <FAC400 {...props} />} />
                        <Route path='/facturacion/FAC402' render={(props) => <FAC402 {...props} />} /> 
                        <Route path='/facturacion/FAC404' render={(props) => <FAC404 {...props} />} />     
                        <Route path='/facturacion/FAC401' render={(props) => <FAC401 {...props} />} />     
                        <Route path='/facturacion/FAC411' render={(props) => <FAC411 {...props} />} />     
                        <Route path='/facturacion/FAC415' render={(props) => <FAC415 {...props} />} />     

                        <Route path={baseUrl + '/preparacion/PRE109'} render={(props) => <PRE109 {...props} />} />
                        <Route path='/preparacion/PRE100' render={(props) => <PRE100 {...props} />} />
                        <Route path='/preparacion/PRE150' render={(props) => <PRE150 {...props} />} />
                        <Route path='/preparacion/COF070' render={(props) => <COF070 {...props} />} />

                        <Route path={baseUrl + '/preparacion/PRE760Custom'} render={(props) => <PRE760Custom {...props} />} />

                    </Suspense>
                </ScrollContextProvider>
            </Layout>
        );
    }


    if (isLogin) {

        return (

            <LoginPage />

        );
    }


    return (
        <Layout
            doneLoading={doneLoading}
            userName={userName}
            userLanguage={userLanguage}
            changeLanguage={changeLanguage}
            isModeTablet={isModeTablet}
        >
            <Loading />
        </Layout>
    );
};




// WEBPACK FOOTER //
// ./src/App.js